import { render } from "./IcoPicSmall.vue?vue&type=template&id=b637dab2"
import script from "./IcoPicSmall.vue?vue&type=script&lang=js"
export * from "./IcoPicSmall.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/Agent/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__